let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("by2jk")).then(() => parcelRequire('9Jeld'));